import './componenteTablaDark.css'
import EmpleadoAsignadoComponenteTablaDark from './EmpleadoAsignadoComponenteTablaDark';
import EstadoComponenteTablaDark from './EstadoComponenteTablaDark';
import { Link } from 'react-router-dom'
export default function ComponenteTablaDark({ stro, estados }) {
    function formatDate(dateString) {
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    }
    const optionsPrioridad = [{ label: '', value: 0 }, { label: 'BAJA', value: 1 }, { label: 'MEDIA', value: 2 }, { label: 'ALTA', value: 3 }]
    const prioridadSeleccionado = optionsPrioridad.find(p => p.value === Number(stro.prioridad));
    return (
        <tr className='bodyTablaDark'>
            <th className='textoBodyTablaDark'>{stro?.nroStro?.toString().substring(3)}</th>
            <th className='textoBodyTablaDark'>{stro?.entryId}</th>
            <th className='textoBodyTablaDark'>{stro?.pza}</th>
            <th className='textoBodyTablaDark'>{stro?.dom}</th>
            <th className='textoBodyTablaDark'>{formatDate(stro?.fechaDenuncia)}</th>
            <th className='textoBodyTablaDark'>{formatDate(stro?.fechaStro)}</th>
            <th className='textoBodyTablaDark'>{stro?.recepcionRecChoques ? formatDate(stro?.recepcionRecChoques) : null}</th>
            <th className='textoBodyTablaDark'>{stro?.fechaVencimiento ? formatDate(stro?.fechaVencimiento) : null}</th>
            <th className='textoBodyTablaDark'>{prioridadSeleccionado.label}</th>
            <EmpleadoAsignadoComponenteTablaDark stro={stro} />
            <EstadoComponenteTablaDark stro={stro} estados={estados} />
            <th className='textoBodyTablaDark'>{stro?.catStro}</th>
            <th className='col-icon'>
                <Link to={`/nuevoStro/${stro?.id}`} className='ingresarContainerBodyDark'>
                    <i className="bi bi-arrow-right" style={{ color: '#42C3BA' }}></i>
                </Link>
            </th>
        </tr>
    );
}
